
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Hinter der Two-Spice-Gruppe, bei der Coop mitbeteiligt ist, steht mit Daniel
Kehl und Marc Saxer ein Duo, das kaum an die Öffentlichkeit tritt. Sie verhalfen
Sushi in den frühen Nullerjahren in Zürich zu Bekanntheit und eröffneten 2013
eine Yooji-Filiale im Einkaufszentrum Westside in Bern. 2015 folgte ein
Take-away-Laden im Hauptbahnhof Bern. Zeitgleich eröffneten sie das Rice Up,
ebenfalls im Foodcourt am HB Bern. Das jüngste Konzept heisst Yalda,
orientalische Restaurants mit Selbstbedienungsbuffet. Die Yalda-Lokale ersetzten
die 2015 eröffneten Burgerläden Jack & Jo., eine Expansion nach Bern ist derzeit
laut einem Unternehmenssprecher nicht angedacht. In Bern arbeiten 45 Personen,
zum Umsatz macht das Unternehmen keine Angaben.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;